import rvr_interior_1_sm from '../../../assets/vehicles/rvr/rvr-interior-1-sm.jpg'
import rvr_interior_1_lg from '../../../assets/vehicles/rvr/rvr-interior-1-lg.jpg'
import rvr_interior_2_sm from '../../../assets/vehicles/rvr/rvr-interior-2-sm.jpg'
import rvr_interior_2_lg from '../../../assets/vehicles/rvr/rvr-interior-2-lg.jpg'

import rvr_exterior_01_sm from '../../../assets/vehicles/rvr/rvr-exterior-01-sm.png'
import rvr_exterior_01_lg from '../../../assets/vehicles/rvr/rvr-exterior-01-lg.png'
import rvr_exterior_02_sm from '../../../assets/vehicles/rvr/rvr-exterior-02-sm.png'
import rvr_exterior_02_lg from '../../../assets/vehicles/rvr/rvr-exterior-02-lg.png'
import rvr_exterior_03_sm from '../../../assets/vehicles/rvr/rvr-exterior-03-sm.png'
import rvr_exterior_03_lg from '../../../assets/vehicles/rvr/rvr-exterior-03-lg.png'
import rvr_exterior_04_sm from '../../../assets/vehicles/rvr/rvr-exterior-04-sm.png'
import rvr_exterior_04_lg from '../../../assets/vehicles/rvr/rvr-exterior-04-lg.png'
import rvr_exterior_05_sm from '../../../assets/vehicles/rvr/rvr-exterior-05-sm.png'
import rvr_exterior_05_lg from '../../../assets/vehicles/rvr/rvr-exterior-05-lg.png'
import rvr_exterior_06_sm from '../../../assets/vehicles/rvr/rvr-exterior-06-sm.png'
import rvr_exterior_06_lg from '../../../assets/vehicles/rvr/rvr-exterior-06-lg.png'
import rvr_exterior_07_sm from '../../../assets/vehicles/rvr/rvr-exterior-07-sm.png'
import rvr_exterior_07_lg from '../../../assets/vehicles/rvr/rvr-exterior-07-lg.png'
import rvr_exterior_08_sm from '../../../assets/vehicles/rvr/rvr-exterior-08-sm.png'
import rvr_exterior_08_lg from '../../../assets/vehicles/rvr/rvr-exterior-08-lg.png'
import rvr_exterior_09_sm from '../../../assets/vehicles/rvr/rvr-exterior-09-sm.png'
import rvr_exterior_09_lg from '../../../assets/vehicles/rvr/rvr-exterior-09-lg.png'
import rvr_exterior_10_sm from '../../../assets/vehicles/rvr/rvr-exterior-10-sm.png'
import rvr_exterior_10_lg from '../../../assets/vehicles/rvr/rvr-exterior-10-lg.png'
import rvr_exterior_11_sm from '../../../assets/vehicles/rvr/rvr-exterior-11-sm.png'
import rvr_exterior_11_lg from '../../../assets/vehicles/rvr/rvr-exterior-11-lg.png'
import rvr_exterior_12_sm from '../../../assets/vehicles/rvr/rvr-exterior-12-sm.png'
import rvr_exterior_12_lg from '../../../assets/vehicles/rvr/rvr-exterior-12-lg.png'
import rvr_exterior_13_sm from '../../../assets/vehicles/rvr/rvr-exterior-13-sm.png'
import rvr_exterior_13_lg from '../../../assets/vehicles/rvr/rvr-exterior-13-lg.png'
import rvr_exterior_14_sm from '../../../assets/vehicles/rvr/rvr-exterior-14-sm.png'
import rvr_exterior_14_lg from '../../../assets/vehicles/rvr/rvr-exterior-14-lg.png'
import rvr_exterior_15_sm from '../../../assets/vehicles/rvr/rvr-exterior-15-sm.png'
import rvr_exterior_15_lg from '../../../assets/vehicles/rvr/rvr-exterior-15-lg.png'
import rvr_exterior_16_sm from '../../../assets/vehicles/rvr/rvr-exterior-16-sm.png'
import rvr_exterior_16_lg from '../../../assets/vehicles/rvr/rvr-exterior-16-lg.png'

import rvr_safety_airbags_1 from '../../../assets/vehicles/rvr/rvr-safety-airbags-1.svg'
import rvr_safety_airbags_2 from '../../../assets/vehicles/rvr/rvr-safety-airbags-2.svg'
import rvr_safety_airbags_3 from '../../../assets/vehicles/rvr/rvr-safety-airbags-3.svg'
import rvr_safety_airbags_4 from '../../../assets/vehicles/rvr/rvr-safety-airbags-4.svg'

import rvr_interior_virtual_tour from '../../../assets/vehicles/rvr/rvr-interior-virtual-tour.jpg'
import rvr_exterior_virtual_tour from '../../../assets/vehicles/rvr/rvr-exterior-virtual-tour.jpg'

export const data = {
  virtualCardImage: {
    interior: rvr_interior_virtual_tour,
    exterior: rvr_exterior_virtual_tour,
  },
  interiorSlides: [
    {
      image: {
        sm: rvr_interior_1_sm,
        lg: rvr_interior_1_lg,
      },
      hotspots: [
        {
          x: 29,
          y: 22,
          action: '??',
          label: 'rvr.interior.image-1.hotspot-1.label',
          message: 'rvr.interior.image-1.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 58,
          y: 58,
          action: '??',
          label: 'rvr.interior.image-1.hotspot-2.label',
          message: 'rvr.interior.image-1.hotspot-2.message',
          position: 'left',
        },
        {
          x: 54,
          y: 71,
          action: '??',
          label: 'rvr.interior.image-1.hotspot-3.label',
          message: 'rvr.interior.image-1.hotspot-3.message',
          position: 'left',
        },
        {
          x: 33,
          y: 81,
          action: '??',
          label: 'rvr.interior.image-1.hotspot-4.label',
          message: 'rvr.interior.image-1.hotspot-4.message',
          position: 'bottom',
        },
        {
          x: 56,
          y: 30,
          action: '??',
          label: 'rvr.interior.image-1.hotspot-5.label',
          message: 'rvr.interior.image-1.hotspot-5.message',
          position: 'bottom',
        },
      ],
    },
    {
      image: {
        sm: rvr_interior_2_sm,
        lg: rvr_interior_2_lg,
      },
      hotspots: [
        {
          x: 57,
          y: 48,
          action: '??',
          label: 'rvr.interior.image-2.hotspot-1.label',
          message: 'rvr.interior.image-2.hotspot-1.message',
          position: 'top',
        },
        {
          x: 56,
          y: 79,
          action: '??',
          label: 'rvr.interior.image-2.hotspot-2.label',
          message: 'rvr.interior.image-2.hotspot-2.message',
          position: 'bottom',
        },
        {
          x: 16,
          y: 44,
          action: '??',
          label: 'rvr.interior.image-2.hotspot-4.label',
          message: 'rvr.interior.image-2.hotspot-4.message',
          position: 'left',
        },
      ],
    },
  ],
  exteriorSlides: [
    {
      image: {
        sm: rvr_exterior_01_sm,
        lg: rvr_exterior_01_lg,
      },
      hotspots: [
        {
          x: 33,
          y: 50,
          action: '??',
          label: 'rvr.exterior.hotspot-1.label',
          message: 'rvr.exterior.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 28,
          y: 68,
          action: '??',
          label: 'rvr.exterior.hotspot-2.label',
          message: 'rvr.exterior.hotspot-2.message',
          position: 'top',
        },
        {
          x: 67,
          y: 65,
          action: '??',
          label: 'rvr.exterior.hotspot-3.label',
          message: 'rvr.exterior.hotspot-3.message',
          position: 'top',
        },
      ],
    },
    {
      image: {
        sm: rvr_exterior_02_sm,
        lg: rvr_exterior_02_lg,
      },
      hotspots: [
        {
          x: 30,
          y: 49,
          action: '??',
          label: 'rvr.exterior.hotspot-1.label',
          message: 'rvr.exterior.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 24,
          y: 66,
          action: '??',
          label: 'rvr.exterior.hotspot-2.label',
          message: 'rvr.exterior.hotspot-2.message',
          position: 'top',
        },
        {
          x: 64,
          y: 67,
          action: '??',
          label: 'rvr.exterior.hotspot-3.label',
          message: 'rvr.exterior.hotspot-3.message',
          position: 'top',
        },
      ],
    },
    {
      image: {
        sm: rvr_exterior_03_sm,
        lg: rvr_exterior_03_lg,
      },
      hotspots: [
        {
          x: 30,
          y: 48,
          action: '??',
          label: 'rvr.exterior.hotspot-1.label',
          message: 'rvr.exterior.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 27,
          y: 64,
          action: '??',
          label: 'rvr.exterior.hotspot-2.label',
          message: 'rvr.exterior.hotspot-2.message',
          position: 'top',
        },
        {
          x: 58,
          y: 68,
          action: '??',
          label: 'rvr.exterior.hotspot-3.label',
          message: 'rvr.exterior.hotspot-3.message',
          position: 'left',
        },
      ],
    },
    {
      image: {
        sm: rvr_exterior_04_sm,
        lg: rvr_exterior_04_lg,
      },
      hotspots: [
        {
          x: 38,
          y: 45,
          action: '??',
          label: 'rvr.exterior.hotspot-1.label',
          message: 'rvr.exterior.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 31,
          y: 65,
          action: '??',
          label: 'rvr.exterior.hotspot-2.label',
          message: 'rvr.exterior.hotspot-2.message',
          position: 'right',
        },
        {
          x: 50,
          y: 65,
          action: '??',
          label: 'rvr.exterior.hotspot-3.label',
          message: 'rvr.exterior.hotspot-3.message',
          position: 'left',
        },
        {
          x: 64,
          y: 42,
          action: '??',
          label: 'rvr.exterior.hotspot-4.label',
          message: 'rvr.exterior.hotspot-4.message',
          position: 'left',
        },
      ],
    },
    {
      image: {
        sm: rvr_exterior_05_sm,
        lg: rvr_exterior_05_lg,
      },
      hotspots: [
        {
          x: 38,
          y: 60,
          action: '??',
          label: 'rvr.exterior.hotspot-2.label',
          message: 'rvr.exterior.hotspot-2.message',
          position: 'right',
        },
        {
          x: 63,
          y: 67,
          action: '??',
          label: 'rvr.exterior.hotspot-3.label',
          message: 'rvr.exterior.hotspot-3.message',
          position: 'left',
        },
        {
          x: 56,
          y: 39,
          action: '??',
          label: 'rvr.exterior.hotspot-4.label',
          message: 'rvr.exterior.hotspot-4.message',
          position: 'bottom',
        },
      ],
    },
    {
      image: {
        sm: rvr_exterior_06_sm,
        lg: rvr_exterior_06_lg,
      },
      hotspots: [
        {
          x: 48,
          y: 68,
          action: '??',
          label: 'rvr.exterior.hotspot-3.label',
          message: 'rvr.exterior.hotspot-3.message',
          position: 'right',
        },
        {
          x: 48,
          y: 39,
          action: '??',
          label: 'rvr.exterior.hotspot-4.label',
          message: 'rvr.exterior.hotspot-4.message',
          position: 'bottom',
        },
        {
          x: 64,
          y: 51,
          action: '??',
          label: 'rvr.exterior.hotspot-5.label',
          message: 'rvr.exterior.hotspot-5.message',
          position: 'left',
        },
      ],
    },
    {
      image: {
        sm: rvr_exterior_07_sm,
        lg: rvr_exterior_07_lg,
      },
      hotspots: [
        {
          x: 42,
          y: 66,
          action: '??',
          label: 'rvr.exterior.hotspot-3.label',
          message: 'rvr.exterior.hotspot-3.message',
          position: 'right',
        },
        {
          x: 42,
          y: 40,
          action: '??',
          label: 'rvr.exterior.hotspot-4.label',
          message: 'rvr.exterior.hotspot-4.message',
          position: 'bottom',
        },
        {
          x: 66,
          y: 43,
          action: '??',
          label: 'rvr.exterior.hotspot-5.label',
          message: 'rvr.exterior.hotspot-5.message',
          position: 'bottom',
        },
      ],
    },
    {
      image: {
        sm: rvr_exterior_08_sm,
        lg: rvr_exterior_08_lg,
      },
      hotspots: [
        {
          x: 64,
          y: 65,
          action: '??',
          label: 'rvr.exterior.hotspot-3.label',
          message: 'rvr.exterior.hotspot-3.message',
          position: 'right',
        },
        {
          x: 64,
          y: 42,
          action: '??',
          label: 'rvr.exterior.hotspot-5.label',
          message: 'rvr.exterior.hotspot-5.message',
          position: 'bottom',
        },
        {
          x: 38,
          y: 40,
          action: '??',
          label: 'rvr.exterior.hotspot-4.label',
          message: 'rvr.exterior.hotspot-4.message',
          position: 'bottom',
        },
      ],
    },
    {
      image: {
        sm: rvr_exterior_09_sm,
        lg: rvr_exterior_09_lg,
      },
      hotspots: [
        {
          x: 62,
          y: 61,
          action: '??',
          label: 'rvr.exterior.hotspot-3.label',
          message: 'rvr.exterior.hotspot-3.message',
          position: 'right',
        },
        {
          x: 35,
          y: 39,
          action: '??',
          label: 'rvr.exterior.hotspot-4.label',
          message: 'rvr.exterior.hotspot-4.message',
          position: 'bottom',
        },
        {
          x: 61,
          y: 42,
          action: '??',
          label: 'rvr.exterior.hotspot-5.label',
          message: 'rvr.exterior.hotspot-5.message',
          position: 'bottom',
        },
      ],
    },
    {
      image: {
        sm: rvr_exterior_10_sm,
        lg: rvr_exterior_10_lg,
      },
      hotspots: [
        {
          x: 68,
          y: 46,
          action: '??',
          label: 'rvr.exterior.hotspot-1.label',
          message: 'rvr.exterior.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 68,
          y: 68,
          action: '??',
          label: 'rvr.exterior.hotspot-2.label',
          message: 'rvr.exterior.hotspot-2.message',
          position: 'left',
        },
        {
          x: 35,
          y: 63,
          action: '??',
          label: 'rvr.exterior.hotspot-3.label',
          message: 'rvr.exterior.hotspot-3.message',
          position: 'top',
        },
        {
          x: 32,
          y: 40,
          action: '??',
          label: 'rvr.exterior.hotspot-4.label',
          message: 'rvr.exterior.hotspot-4.message',
          position: 'bottom',
        },
        {
          x: 56,
          y: 54,
          action: '??',
          label: 'rvr.exterior.hotspot-5.label',
          message: 'rvr.exterior.hotspot-5.message',
          position: 'left',
        },
      ],
    },
    {
      image: {
        sm: rvr_exterior_11_sm,
        lg: rvr_exterior_11_lg,
      },
      hotspots: [
        {
          x: 65,
          y: 46,
          action: '??',
          label: 'rvr.exterior.hotspot-1.label',
          message: 'rvr.exterior.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 62,
          y: 69,
          action: '??',
          label: 'rvr.exterior.hotspot-2.label',
          message: 'rvr.exterior.hotspot-2.message',
          position: 'left',
        },
        {
          x: 31,
          y: 69,
          action: '??',
          label: 'rvr.exterior.hotspot-3.label',
          message: 'rvr.exterior.hotspot-3.message',
          position: 'top',
        },
        {
          x: 37,
          y: 41,
          action: '??',
          label: 'rvr.exterior.hotspot-4.label',
          message: 'rvr.exterior.hotspot-4.message',
          position: 'bottom',
        },
        {
          x: 50,
          y: 54,
          action: '??',
          label: 'rvr.exterior.hotspot-5.label',
          message: 'rvr.exterior.hotspot-5.message',
          position: 'left',
        },
      ],
    },
    {
      image: {
        sm: rvr_exterior_12_sm,
        lg: rvr_exterior_12_lg,
      },
      hotspots: [
        {
          x: 61,
          y: 47,
          action: '??',
          label: 'rvr.exterior.hotspot-1.label',
          message: 'rvr.exterior.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 52,
          y: 69,
          action: '??',
          label: 'rvr.exterior.hotspot-2.label',
          message: 'rvr.exterior.hotspot-2.message',
          position: 'left',
        },
        {
          x: 34,
          y: 64,
          action: '??',
          label: 'rvr.exterior.hotspot-3.label',
          message: 'rvr.exterior.hotspot-3.message',
          position: 'right',
        },
        {
          x: 41,
          y: 50,
          action: '??',
          label: 'rvr.exterior.hotspot-5.label',
          message: 'rvr.exterior.hotspot-5.message',
          position: 'right',
        },
      ],
    },
    {
      image: {
        sm: rvr_exterior_13_sm,
        lg: rvr_exterior_13_lg,
      },
      hotspots: [
        {
          x: 51,
          y: 46,
          action: '??',
          label: 'rvr.exterior.hotspot-1.label',
          message: 'rvr.exterior.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 42,
          y: 68,
          action: '??',
          label: 'rvr.exterior.hotspot-2.label',
          message: 'rvr.exterior.hotspot-2.message',
          position: 'left',
        },
        {
          x: 38,
          y: 47,
          action: '??',
          label: 'rvr.exterior.hotspot-5.label',
          message: 'rvr.exterior.hotspot-5.message',
          position: 'right',
        },
      ],
    },
    {
      image: {
        sm: rvr_exterior_14_sm,
        lg: rvr_exterior_14_lg,
      },
      hotspots: [
        {
          x: 42,
          y: 45,
          action: '??',
          label: 'rvr.exterior.hotspot-1.label',
          message: 'rvr.exterior.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 29,
          y: 64,
          action: '??',
          label: 'rvr.exterior.hotspot-2.label',
          message: 'rvr.exterior.hotspot-2.message',
          position: 'top',
        },
        {
          x: 65,
          y: 60,
          action: '??',
          label: 'rvr.exterior.hotspot-3.label',
          message: 'rvr.exterior.hotspot-3.message',
          position: 'top',
        },
        {
          x: 35,
          y: 46,
          action: '??',
          label: 'rvr.exterior.hotspot-5.label',
          message: 'rvr.exterior.hotspot-5.message',
          position: 'right',
        },
      ],
    },
    {
      image: {
        sm: rvr_exterior_15_sm,
        lg: rvr_exterior_15_lg,
      },
      hotspots: [
        {
          x: 37,
          y: 48,
          action: '??',
          label: 'rvr.exterior.hotspot-1.label',
          message: 'rvr.exterior.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 27,
          y: 69,
          action: '??',
          label: 'rvr.exterior.hotspot-2.label',
          message: 'rvr.exterior.hotspot-2.message',
          position: 'top',
        },
        {
          x: 66,
          y: 65,
          action: '??',
          label: 'rvr.exterior.hotspot-3.label',
          message: 'rvr.exterior.hotspot-3.message',
          position: 'top',
        },
      ],
    },
    {
      image: {
        sm: rvr_exterior_16_sm,
        lg: rvr_exterior_16_lg,
      },
      hotspots: [
        {
          x: 34,
          y: 46,
          action: '??',
          label: 'rvr.exterior.hotspot-1.label',
          message: 'rvr.exterior.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 28,
          y: 69,
          action: '??',
          label: 'rvr.exterior.hotspot-2.label',
          message: 'rvr.exterior.hotspot-2.message',
          position: 'top',
        },
        {
          x: 66,
          y: 61,
          action: '??',
          label: 'rvr.exterior.hotspot-3.label',
          message: 'rvr.exterior.hotspot-3.message',
          position: 'top',
        },
      ],
    },
  ],
  safetyTabs: [
    {
      label: 'rvr.blueprint.safety.tab-1',
      image: rvr_safety_airbags_1,
      dots: [
        {
          top: -5,
          left: 45,
          label: 'rvr.blueprint.safety.hotspot-1.label',
          message: 'rvr.blueprint.safety.hotspot-1.message',
          position: 'bottom',
        },
      ],
    },
    {
      label: 'rvr.blueprint.safety.tab-2',
      image: rvr_safety_airbags_2,
      dots: [
        {
          top: 52,
          left: 25,
          label: 'rvr.blueprint.safety.hotspot-2.label',
          message: 'rvr.blueprint.safety.hotspot-2.message',
          position: 'top',
        },
      ],
    },
    {
      label: 'rvr.blueprint.safety.tab-3',
      image: rvr_safety_airbags_3,
      dots: [
        {
          top: 7,
          left: 43,
          label: 'rvr.blueprint.safety.hotspot-3.label',
          message: 'rvr.blueprint.safety.hotspot-3.message',
          position: 'bottom',
        },
      ],
    },
    {
      label: 'rvr.blueprint.safety.tab-4',
      image: rvr_safety_airbags_4,
      dots: [
        {
          top: 16,
          left: 3,
          label: 'rvr.blueprint.safety.hotspot-4.label',
          message: 'rvr.blueprint.safety.hotspot-4.message',
          position: 'bottom',
        },
      ],
    },
  ],
}
